var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 3.83333C11.9667 3.83333 13.8333 5.7 13.8333 8C13.8333 8.54167 13.725 9.05 13.5333 9.525L15.9667 11.9583C17.225 10.9083 18.2167 9.55 18.825 8C17.3833 4.34167 13.825 1.75 9.65833 1.75C8.49167 1.75 7.375 1.95833 6.34167 2.33333L8.14167 4.13333C8.61667 3.94167 9.125 3.83333 9.66667 3.83333ZM1.33333 1.55833L3.61667 3.84167C2.23333 4.91667 1.15 6.35 0.5 8C1.94167 11.6583 5.5 14.25 9.66667 14.25C10.9583 14.25 12.1917 14 13.3167 13.55L13.6667 13.9L16.1083 16.3333L17.1667 15.275L2.39167 0.5L1.33333 1.55833ZM5.94167 6.16667L7.23333 7.45833C7.19167 7.63333 7.16667 7.81667 7.16667 8C7.16667 9.38333 8.28333 10.5 9.66667 10.5C9.85 10.5 10.0333 10.475 10.2083 10.4333L11.5 11.725C10.9417 12 10.325 12.1667 9.66667 12.1667C7.36667 12.1667 5.5 10.3 5.5 8C5.5 7.34167 5.66667 6.725 5.94167 6.16667ZM9.53333 5.51667L12.1583 8.14167L12.175 8.00833C12.175 6.625 11.0583 5.50833 9.675 5.50833L9.53333 5.51667Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/closedEye.6c1c1f985f3867f29fd570e30a277383.svg";
export { ForwardRef as ReactComponent };